import React from 'react';
import { useErrorOverlayState } from './GlobalRuntimeState';
import ErrorBoundary from './ErrorBoundary';

/**
 * Shows the error overlay, instead of the page that failed to render.
 */
function PageError(): null {
    const [, setErrorOverlay] = useErrorOverlayState();
    React.useEffect(() => {
        setErrorOverlay({ isShown: true });
    }, []);
    return null;
}

/**
 * Stops an error in a page from unmounting the whole site, which would leave
 * a blank page. The navigation and footer stay, and the error overlay offers
 * to reload.
 */
export default function PageErrorBoundary({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    return <ErrorBoundary fallback={<PageError />}>{children}</ErrorBoundary>;
}
